let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d6Uqx")).then(() => parcelRequire('gzIjF'));